import React from 'react';
import axios from 'axios';
import {Button, Form, Input, Table} from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import CreateCourse from './CreateCourse';
import SearchTableData from "../../util/SearchTableData";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;


class BasicCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            courses: [],
            courseName: '',

            openAddCourseMode: false,

            results: []
        };
        this.openAddCourseMode = this.openAddCourseMode.bind(this);
        this.addCourse = this.addCourse.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    openAddCourseMode(id, name) {
        this.setState({
            openAddCourseMode: !this.state.openAddCourseMode, id, name
        });
    }

    addCourse(courseBasicId) {
        this.setState({ openAddCourseMode: false });
        if (this.props.addCourseSemestersAfter) this.props.getSemesters();
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.data;
    }

    getResults(results) {
        this.setState({ results });
    }

    render() {
        return (

            <div>
                {this.state.openAddCourseMode &&
                    <CreateCourse
                        semesterId={this.props.semesterId}
                        courseBasicId={this.state.id}
                        openAddCourseMode={this.openAddCourseMode}
                        addCourse={this.addCourse}
                        name={this.state.name}
                        id={this.state.id}
                        newSPId={this.props.newSPId}
                        sPsemesterId={this.props.sPsemesterId}
                    />}

                {this.getDataToRender().length  ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={4} >
                                    <div style={{paddingLeft: '30px'}}>
                                        <SearchTableData data={this.props.data} getResults={this.getResults} filterItem={['name']} />
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Naziv predmeta
                                </Table.HeaderCell>
                                {/* <Table.HeaderCell> */}
                                {/*    Šifra predmeta */}
                                {/* </Table.HeaderCell> */}
                                <Table.HeaderCell>
                                    Komentar
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Matični fakultet
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle">
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.comment}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.mainFaculty.name}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle">
                                    <Button
                                        color="blue"
                                        size="small"
                                        basic="true"
                                        onClick={() => { window.scrollTo(0, 300); this.openAddCourseMode(el.id, el.name); }}
                                    >  Dodaj u semestar
                                    </Button>

                                </Table.Cell>

                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : <NoDataMessage />
                }
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default BasicCourses;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/BasicCourses.js